export default __webpack_public_path__ + "static/media/landing_3.20bb6075.jpg";